import SocialLogin from './SocialLogin.page';

export default SocialLogin;